import { Link } from 'react-router-dom'
import { business } from '../data/siteData'
import BackgroundFX from './BackgroundFX'
import ScrollReveal from './ScrollReveal'
import { bgPhoto } from '../utils/img'
import './CTASection.css'

export default function CTASection() {
  return (
    <section
      className="cta-section"
      style={{ backgroundImage: `url(${bgPhoto('/images/bg/bg3.webp', 1800, 900)})` , width:"500",
    height:"500" }}
    >
      <div className="cta-scrim" />
      <BackgroundFX count={10} />
      <div className="container cta-inner">
        <ScrollReveal>
          <span className="eyebrow">Let's Talk</span>
          <h2>Have a date in mind? Let's build the room around it.</h2>
          <p>
            Tell us your event type, date and guest count — we'll get back with a plan
            and a quote within one business day.
          </p>
          <div className="cta-actions">
            <Link to="/booking" className="btn btn-primary">Start Your Booking</Link>
            <a href={business.phoneHref} className="btn btn-ghost">Call {business.phone}</a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  )
}
